import styled from "@emotion/styled";
import { Box, IconButton, Typography } from "@mui/material";
import { ReactComponent as EditIcon } from "Components/_Shared/Icons/Assets/edit.svg";
import { useEffect, useState } from "react";

type Props = {
  readonly value: string;
  readonly onChange: (value: string) => void;
  readonly readOnly?: boolean;
};

const StyledInput = styled.input`
  outline: 0;
  border: 0;
  font-size: 24px;
  font-family: "Fedra Sans Pro";
  background: transparent;
  width: 100%;
`;

export const EditableTitle: React.FC<Props> = (props) => {
  const [isEditing, setIsEditing] = useState(false);
  const [value, setValue] = useState<string>(props.value);

  const handleSave = () => {
    setIsEditing(false);
    props.onChange(value);
  };

  useEffect(() => {
    setValue(props.value);
  }, [props.value]);

  if (!isEditing) {
    return (
      <Box display="flex">
        <Typography variant="h2">{value}</Typography>
        {!props.readOnly && (
          <IconButton sx={{ ml: 2 }} onClick={() => setIsEditing(true)}>
            <EditIcon height={16} width={16} />
          </IconButton>
        )}
      </Box>
    );
  }

  return (
    <StyledInput
      maxLength={50}
      value={value}
      onBlur={handleSave}
      onChange={(event) => {
        setValue(event.target.value);
      }}
      onKeyDown={(event) => (event.key === "Enter" || event.key === "Escape") && handleSave()}
      autoFocus
    />
  );
};
